import React from "react";
import { Link } from "react-router-dom";

// Transparent wordmark. `light` uses the cream version for dark backgrounds.
export const Logo = ({ className = "h-9", light = false }) => (
  <Link to="/" data-testid="site-logo" className="inline-flex items-center">
    <img
      src={light ? "/assets/logo-light.png" : "/assets/logo.png"}
      alt="Baby Hemp"
      className={`${className} w-auto select-none`}
      draggable={false}
    />
  </Link>
);
